import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Not all libraries support group analytics yet, but you can work around this issue by sending events in specific formats.`}</p>
    <p>{`This section uses our `}<a parentName="p" {...{
        "href": "https://posthog.com/docs/api/post-only-endpoints"
      }}>{`Capture APIs`}</a>{` for examples but you can adapt this
approach to any library.`}</p>
    <h4 {...{
      "id": "capturing-events-with-groups"
    }}>{`Capturing events with groups`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`POST https://[your-instance].com/capture/
Content-Type: application/json
Body:
{
    "api_key": "<ph_project_api_key>",
    "event": "[event name]",
    "properties": {
        "distinct_id": "[your users' distinct id]",
        "key1": "value1",
        "key2": "value2",
        "$groups": {
            "company": "id:5"
        }
    }
}

`}</code></pre>
    <h4 {...{
      "id": "updating-group-properties"
    }}>{`Updating group properties`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`POST https://[your-instance].com/capture/
Content-Type: application/json
Body:
{
    "api_key": "<ph_project_api_key>",
    "event": "$groupidentify",
    "properties": {
        "distinct_id": "[your users' distinct id]",
        "$group_type": "company",
        "$group_key": "id:5",
        "$group_set": {
            "company_name": "Awesome Inc",
            "employees": 11
        }
    }
}

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      